"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onSnapshot = exports.isOptions = void 0;
var firestore_1 = require("firebase/firestore");
var isOptions = function (arg) {
    var v = arg;
    return (v === null || v === void 0 ? void 0 : v.includeMetadataChanges) !== undefined; // includeMetadataChanges is boolean, so check for undefined
};
exports.isOptions = isOptions;
var onSnapshot = function (reference, onNext, onError, onCompletion, options) {
    var newOnError = (0, exports.isOptions)(onError) ? undefined : onError;
    var newOncCompletion = (0, exports.isOptions)(onCompletion) ? undefined : onCompletion;
    var newOptions = options ||
        ((0, exports.isOptions)(onError) ? onError : undefined) ||
        ((0, exports.isOptions)(onCompletion) ? onCompletion : undefined);
    return newOptions
        ? (0, firestore_1.onSnapshot)(reference, newOptions, {
            // @ts-expect-error
            next: onNext,
            error: newOnError,
            complete: newOncCompletion,
        })
        : (0, firestore_1.onSnapshot)(reference, 
        // @ts-expect-error
        onNext, newOnError, newOncCompletion);
};
exports.onSnapshot = onSnapshot;
